<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div
        class="form-wrapper"
        :style="{ height: resizeViewHeight - 20 + 'px' }"
      >
        <el-tabs v-model="activeName">
          <!-- <el-tab-pane
            label="超速报警"
            name="overSpeedAlarm"
            v-if="isCreate || editType == 16"
          >
            <overSpeedAlarm :alarmSetId="alarmSetId"></overSpeedAlarm>
          </el-tab-pane> -->
          <!-- <el-tab-pane
            label="劫警"
            name="lootAlarm"
            v-if="isCreate || editType == 512"
          >
            <lootAlarm :alarmSetId="alarmSetId"></lootAlarm>
          </el-tab-pane> -->
          <el-tab-pane
            label="停车报警"
            name="stopAlarm"
            v-if="isCreate || editType == 1024"
          >
            <stopAlarm :alarmSetId="alarmSetId"></stopAlarm>
          </el-tab-pane>
          <!-- <el-tab-pane
            label="疲劳驾驶报警"
            name="fatigueDriverAlarm"
            v-if="isCreate || editType == 256"
          >
            <fatigueDriverAlarm :alarmSetId="alarmSetId"></fatigueDriverAlarm>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import resizeListener from "_private/mixins/resizeListener";
// import overSpeedAlarm from "@/views/alarmSet/commonAlarmSet/OverSpeedAlarm.vue";
// import lootAlarm from "@/views/alarmSet/commonAlarmSet/LootAlarm.vue";
import stopAlarm from "@/views/alarmSet/commonAlarmSet/StopAlarm.vue";
// import fatigueDriverAlarm from "@/views/alarmSet/commonAlarmSet/FatigueDriverAlarm.vue";
export default {
  mixins: [resizeListener],
  components: { stopAlarm },
  data: function() {
    return {
      loadingState: false,
      activeName: "stopAlarm",
      pageTitle: "新增报警",
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "主页"
          }
        },
        {
          path: "/alarmSetCommonAlarmSetList",
          isRedirect: true,
          meta: {
            title: "常用报警设置列表"
          }
        }
      ]
    };
  },
  computed: {
    //是否新增
    isCreate() {
      return this.$route.query.isCreate ? this.$route.query.isCreate : false;
    },
    //编辑报警类型
    editType() {
      return this.$route.query.editType ? this.$route.query.editType : 0;
    },
    //报警ID
    alarmSetId() {
      return this.$route.query.alarmSetId ? this.$route.query.alarmSetId : 0;
    }
  },
  created() {
    if (this.editType != 0) {
      //编辑时设置当前显示tab页
      this.setActiveName();
      this.pageTitle = "编辑报警";
    }
    let breadcrumb = {
      path: "/alarmSetCommonAlarmEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
  },
  methods: {
    //设置当前显示tab页
    setActiveName() {
      switch (Number(this.editType)) {
        case 16:
          this.activeName = "overSpeedAlarm";
          break;
        case 512:
          this.activeName = "lootAlarm";
          break;
        case 1024:
          this.activeName = "stopAlarm";
          break;
        case 256:
          this.activeName = "fatigueDriverAlarm";
          break;
        default:
          this.activeName = "overSpeedAlarm";
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}

.content-section {
  overflow: auto;
}

.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}

/deep/ .e6-from--column-2 {
  .el-input {
    width: 240px;
  }
  .el-textarea__inner {
    width: 240px;
  }
}
.el-tabs {
  height: 100%;
  /deep/ .el-tabs__content {
    height: calc(100% - 55px);
    .el-tab-pane {
      height: 100%;
      .common-alarm-bg {
        height: 100%;
        .common-alarm-div {
          height: calc(100% - 100px);
        }
      }
    }
  }
}
</style>
